import { Box, Flex, Text } from "@chakra-ui/react"
import { faComment } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Modal } from "@morressier/alembic"
import { ISubmissionFile } from "@publishing-engine/domain/models";
import MultilineText from "src/components/MultilineText";
import { useSubmissionData } from "src/contexts/SubmissionDataProvider";
import { AuthorResponseAttachments } from "../feedback/AuthorAttachments";
type IProps = {
  isOpen: boolean;
  onClose: () => void;
}

const ReviewResponseModal = ({ isOpen, onClose }: IProps) => {
  const {
    fieldsResponse: { fields }
  } = useSubmissionData();
  const authorResponse = fields.AuthorResponse?.value as string;
  const authorResponseAttachments = fields.AuthorResponseAttachments
    ?.value as ISubmissionFile[];
    
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="720px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex direction={'column'} padding={6} gap={3}>
        <Box>
          <FontAwesomeIcon icon={faComment} size='2x' />
        </Box>
        <Text textStyle='headingGroup' marginY={3}>Your Response</Text>
        {authorResponse && (
          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingItem">Response to Review Comments</Text>
            <MultilineText textStyle="textBody" text={authorResponse} />
          </Flex>
        )}

        <AuthorResponseAttachments
          authorResponseAttachments={authorResponseAttachments}
        />
        <Flex gap={3} justifyContent={'flex-end'}>
          <Button onClick={onClose}>Close</Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default ReviewResponseModal